import { PaymentMethod } from '../../../../contracts';
import { AutoTextSize } from '../AutoTextSize/AutoTextSize';
import { useAppConfig } from '../../../../hooks/use-app-config';
import { getIsSupercellTemplate } from '../../../../utils/get-is-supercell-template';

import './style.scss';

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

interface PaymentMethodProps {
  isSelected: boolean;
  displayName: string;
  onPaymentMethodChange: (value: PaymentMethod) => void;
  paymentMethodData: PaymentMethod;
}

export function VisiblePaymentMethod({
  isSelected,
  displayName,
  onPaymentMethodChange,
  paymentMethodData,
}: PaymentMethodProps) {
  const { theme } = useAppConfig();

  return (
    <div
      style={{
        borderColor: isSelected ? theme?.button.color : '',
        background: isSelected && IS_SUPERCELL_TEMPLATE ? `${theme?.button.color}0D` : '',
      }}
      className={`payment-method visible ${isSelected ? 'active' : ''}`}
      onClick={() => {
        onPaymentMethodChange(paymentMethodData);
      }}
    >
      <img
        className="payment-method-logo"
        src={`https://media.appcharge.com/defaults/apm_logos/${paymentMethodData.paymentMethodName}_logo.png`}
        alt="payment method icon"
      />
      <AutoTextSize
        as={'h3'}
        minFontSizePx={11}
        maxFontSizePx={12}
        mode="multiline"
        title={displayName}
        className="payment-method-name"
      >
        {displayName}
      </AutoTextSize>
    </div>
  );
}
